import { render } from "./FixedBody.vue?vue&type=template&id=7bbd493a"
import script from "./FixedBody.vue?vue&type=script&lang=js"
export * from "./FixedBody.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__